export const SITE_URL = 'https://www.stratapro.net';
export const BRAND_NAME = 'StrataPro';
export const DEFAULT_TITLE =
  'StrataPro | Strata Management Software for Small Buildings';
export const DEFAULT_DESCRIPTION =
  'StrataPro helps duplexes and small strata committees (2-12 lots) manage AGMs, compliance, records, communication, and costs with practical software built for owner-led buildings.';

export const CONTACT_EMAIL = 'hello@stratapro.com.au';

export const ALL_ROUTES = [
  '/',
  '/about',
  '/pricing',
  '/contact',
  '/get-started',
  '/privacy',
  '/self-managed-strata-software',
  '/duplex-strata-management',
  '/small-strata-committee-software',
  '/strata-agm-guide',
  '/strata-management-cost-comparison',
  '/stratapro-vs-traditional-strata-manager',
  '/stratapro-vs-spreadsheets-self-managed',
  '/benchmark-report-small-strata-operations',
  '/compliance/nsw-strata',
  '/compliance/vic-strata',
  '/compliance/qld-strata',
  '/resources/pr-hub',
  '/resources/agm-notice-template',
  '/resources/agm-agenda-template',
  '/resources/agm-minutes-template',
  '/resources/motion-register-template',
  '/resources/breach-issue-log-template',
  '/resources/maintenance-request-workflow-template',
  '/resources/budget-planning-checklist',
  '/resources/committee-handover-checklist',
  '/resources/vendor-comparison-scorecard',
  '/resources/meeting-notice-timing-explainer',
  '/resources/strata-records-checklist',
  '/resources/vendor-brief-template',
  '/editorial-standards'
] as const;
